// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  lobbyId: __t.string(),
  sequence: __t.u32(),
  keyForward: __t.bool(),
  keyBack: __t.bool(),
  keyLeft: __t.bool(),
  keyRight: __t.bool(),
  keyBoost: __t.bool(),
  keyShift: __t.bool(),
  mouseShoot: __t.bool(),
  mouseScreenX: __t.i32(),
  mouseScreenY: __t.i32(),
  canvasWidth: __t.u16(),
  canvasHeight: __t.u16(),
};
